import React, { createContext, useMemo, useState } from 'react';

const ReportsContext = createContext();

function ReportsProvider({ children }) {
    const [reloadKey, setReloadKey] = useState(0);

    const value = useMemo(() => {
        console.log('Reports Provider');
        return {
            reloadKey,
            setReloadKey
        };
    }, [reloadKey]);

    return <ReportsContext.Provider value={value}>{children}</ReportsContext.Provider>;
}

export default ReportsProvider;
